import React from 'react';
import {t} from 'react-switch-lang';
import Modal from 'reactstrap/lib/Modal';
import TextArea from '../../../../components/FormFields/Textarea';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import * as yup from 'yup';
import {verifyIncurredRisk} from '../../../../services/IncurredEvent/incurredEventApi';
import './modal.scss';
import Toast from '../../../../components/toast/Toast';

function MeasuresFromShow({id, open, isOpen}) {
  const schema = yup.object().shape({
    comment: yup.string()
        .max(1000, t('message.max', {max: 1000})),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch} = methods;
  const toggleShowModal = (e) => {
    e && e.preventDefault();
    isOpen(!open);
  };

  const watchComment = watch('comment');
  const submitForm = async (data) => {
    const payload = {
      accepted: true,
      comment: data.comment,
    };
    try {
      const response = await verifyIncurredRisk(id, payload);
      if (response.status === 200) {
        isOpen(!open);
        await Toast.fire({
          title: t('message.verifyAcceptedRisk'),
          icon: 'success',
        });
      }
      await window.location.reload();
      /*   await history.push(`/dashboard`); */
    } catch (err) {
      // console.log(err, 'error');
    }
  };

  const handleCancel = async (e) => {
    e.preventDefault();
    const payload = {
      accepted: false,
      comment: watchComment,
    };
    try {
      const response = await verifyIncurredRisk(id, payload);
      if (response.status === 200) {
        isOpen(!open);
        await Toast.fire({
          title: t('message.verifyRefusedRisk'),
          icon: 'success',
        });
      }
      await window.location.reload();
    } catch (err) {
      // console.log(err, 'error');
    }
  };
  return (
    <>
      <Modal isOpen={open} className="modal-sm verify-modal">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submitForm)}>
            <div className="close-img">
              <img
                src="/images/exclusion.svg"
                alt="Exclusion"
                onClick={(e) => toggleShowModal(e)}
                style={{cursor: 'pointer'}}
              />
            </div>
            <div className="modal-header history-header">
              {t('common.verify-title-risk')}
            </div>
            <div className="modal-body verify-modal">
              <TextArea
                name="comment"
                className="form-control text-area"
                placeholder={t('placeholder.comment')}
              />
            </div>
            <div className="modal-footer history-footer">
              <button className="secondary-btn" onClick={handleCancel}>
                {t('buttons.refuse')}
              </button>
              <button className="primary-btn">{t('buttons.accept')}</button>
            </div>
          </form>
        </FormProvider>
      </Modal>
    </>
  );
}

export default MeasuresFromShow;
